import SuccessRoundImage from '../../assets/images/success-round.webp';
import useTranslation from '../../localization/i18n.context';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import { useEffect } from 'preact/hooks';
import SuccessFeedbackScreen from '../../components/shared/SuccessFeedbackScreen/SuccessFeedbackScreen';
import NavigationUtils from '../../utils/navigation.utils';
import OnboardingStatusUrlUtils from '../../utils/onboarding-status-url.utils';
import { TrackingEvent } from '../../sdk/tracking.event';

const navigateToPickup = () => {
  NavigationUtils.navigate(NavigationUtils.Routes.PICKUP);
};

const OnboardingSuccessConfig = {
  [OnboardingStatusUrlUtils.OnboardingSuccessType.CARD_APPROVED]: {
    image: SuccessRoundImage,
    title: "You're approved for {card name}",
    subtitle:
      'Visit a {card name} pick up point to collect and activate your new card!',
    ctaText: 'See pick up locations',
    eventName: 'approved',
    ctaAction: navigateToPickup,
    onCloseClick: () => {
      CloseWebviewEvent.finishSuccessfully();
    },
  },
  [OnboardingStatusUrlUtils.OnboardingSuccessType.APPLICATION_REVIEW]: {
    image: SuccessRoundImage,
    title: 'Reviewing application',
    subtitle:
      'Visit a {card name} pick up point to speed up your approval and collect your card!',
    ctaText: 'See pick up locations',
    eventName: 'reviewing_application',
    ctaAction: navigateToPickup,
    onCloseClick: () => {
      CloseWebviewEvent.finishSuccessfully();
    },
  },
};

export default function OnboardingSuccessPage({
  organization: organizationCode,
  type,
  personalizedCard,
}) {
  const { t, getOrganization } = useTranslation();

  const data = OnboardingSuccessConfig[type];

  useEffect(() => {
    TrackingEvent.trigger(
      TrackingEvent.Events.ONBOARDING_FEEDBACK_SHOW,
      TrackingEvent.Sources.CAAS,
      {
        status: data.eventName,
      },
    );
  }, [type]);

  return (
    <>
      {data && (
        <SuccessFeedbackScreen
          onCloseClick={data.onCloseClick}
          image={data.image}
          title={t(data.title, {
            '{card name}': getOrganization(organizationCode),
          })}
          subtitle={
            personalizedCard === 'true'
              ? undefined
              : t(data.subtitle, {
                  '{card name}': getOrganization(organizationCode),
                })
          }
          ctaAction={
            personalizedCard === 'true'
              ? () => {
                  CloseWebviewEvent.finishSuccessfully();
                }
              : navigateToPickup
          }
          ctaText={personalizedCard === 'true' ? t('Close') : t(data.ctaText)}
        />
      )}
    </>
  );
}
